import request from '@/utils/request'


// 查询敏感词列表
export function listWords(query) {
  return request({
    url: '/video/sensitive-words/list',
    method: 'get',
    params: query
  })
}

// 查询敏感词分页
export function pageWords(query) {
  return request({
    url: '/video/sensitive-words/page',
    method: 'get',
    params: query
  })
}

// 查询敏感词详细
export function getWords(data) {
  return request({
    url: '/video/sensitive-words/detail',
    method: 'get',
    params: data
  })
}

// 新增敏感词
export function addWords(data) {
  return request({
    url: '/video/sensitive-words/add',
    method: 'post',
    data: data
  })
}

// 修改敏感词
export function updateWords(data) {
  return request({
    url: '/video/sensitive-words/edit',
    method: 'post',
    data: data
  })
}

export function importData (data) {
  return request({
    url: '/video/sensitive-words/importData',
    method: 'post',
    data: data
  })
}

// 删除敏感词
export function delWords(data) {
  return request({
    url: '/video/sensitive-words/delete',
    method: 'post',
    data: data
  })
}
